module.exports = __webpack_public_path__ + "img/DSC_0006.5ee828f1.jpg";